var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("User terms and conditions page")]),_vm._v(" "),_c('p',[_vm._v("\n    Terms and conditions content\n  ")])])
}]

export { render, staticRenderFns }